import React from 'react';
import { IconProps } from './types';

const Search: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.7074 19.2944L17.3197 15.9092C18.5684 14.3017 19.1575 12.2787 18.9669 10.2522C18.7764 8.22558 17.8207 6.34781 16.2943 5.00118C14.7679 3.65455 12.7856 2.94032 10.7511 3.00391C8.71657 3.0675 6.78277 3.90413 5.34345 5.34345C3.90413 6.78277 3.0675 8.71657 3.00391 10.7511C2.94032 12.7856 3.65455 14.7679 5.00118 16.2943C6.34781 17.8207 8.22558 18.7764 10.2522 18.9669C12.2787 19.1575 14.3017 18.5684 15.9092 17.3197L19.2944 20.7074C19.3872 20.8001 19.4973 20.8737 19.6185 20.9239C19.7397 20.9742 19.8697 21 20.0009 21C20.1321 21 20.262 20.9742 20.3832 20.9239C20.5044 20.8737 20.6146 20.8001 20.7074 20.7074C20.8001 20.6146 20.8737 20.5044 20.9239 20.3832C20.9742 20.262 21 20.1321 21 20.0009C21 19.8697 20.9742 19.7397 20.9239 19.6185C20.8737 19.4973 20.8001 19.3872 20.7074 19.2944ZM11.0138 17.0052C9.82878 17.0052 8.6704 16.6538 7.68512 15.9954C6.69983 15.3371 5.9319 14.4014 5.47842 13.3066C5.02495 12.2118 4.9063 11.0071 5.13748 9.8449C5.36866 8.68268 5.93929 7.61511 6.7772 6.7772C7.61511 5.93929 8.68268 5.36866 9.8449 5.13748C11.0071 4.9063 12.2118 5.02495 13.3066 5.47842C14.4014 5.9319 15.3371 6.69983 15.9954 7.68512C16.6538 8.6704 17.0052 9.82878 17.0052 11.0138C17.0052 12.6028 16.3739 14.1267 15.2503 15.2503C14.1267 16.3739 12.6028 17.0052 11.0138 17.0052Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default Search;
